import { AxiosRequestConfig } from 'axios'

import {
  CreateMembershipPayload,
  UpdateMembershipData,
  UpdateMembershipPrizeOrderData,
} from './types'

const getMemberships = (): AxiosRequestConfig => ({
  url: '/memberships',
  method: 'GET',
  params: {
    avoidFilterTags: true,
  },
})

const createMembership = (Membership: CreateMembershipPayload): AxiosRequestConfig => {
  const payload = new FormData()
  const {
    title,
    amountVisits,
    pushTitle,
    pushDescription,
    pushMessage,
    backgroundColor,
    recategorizationDays,
  } = Membership

  payload.append('title', title)
  payload.append('amountVisits', amountVisits)
  if (pushTitle) payload.append('pushTitle', pushTitle)
  if (pushDescription) payload.append('pushDescription', pushDescription)
  if (pushMessage) payload.append('pushMessage', pushMessage.toString())
  if (backgroundColor) payload.append('backgroundColor', backgroundColor)
  if (recategorizationDays) payload.append('recategorizationDays', recategorizationDays.toString())

  return {
    url: '/memberships',
    method: 'POST',
    data: payload,
  }
}

const updateMembership = (Membership: UpdateMembershipData): AxiosRequestConfig => {
  const isEcardEnabled = process.env.REACT_APP_ECARD_ENABLED === 'true'
  const payload = new FormData()
  const {
    title,
    amountVisits,
    pushTitle,
    pushDescription,
    pushMessage,
    backgroundColor,
    recategorizationDays,
  } = Membership.payload

  payload.append('title', title)
  // Don't send amountVisits for E-Card projects
  if (!isEcardEnabled) {
    payload.append('amountVisits', amountVisits)
  }
  if (pushTitle) payload.append('pushTitle', pushTitle)
  if (pushDescription) payload.append('pushDescription', pushDescription)
  if (pushMessage !== undefined) payload.append('pushMessage', pushMessage.toString())
  if (backgroundColor) payload.append('backgroundColor', backgroundColor)
  if (recategorizationDays) payload.append('recategorizationDays', recategorizationDays.toString())

  return {
    url: `/memberships/${Membership.id}`,
    method: 'PUT',
    data: payload,
  }
}

const updateMembershipPrizesOrder = (data: UpdateMembershipPrizeOrderData): AxiosRequestConfig => {
  const { id, prizes } = data
  return {
    url: `/memberships/${id}/order`,
    method: 'PUT',
    data: {
      prizes: prizes.map(el => el.id),
    },
  }
}

const deleteMembership = (id: number): AxiosRequestConfig => ({
  url: `/memberships/${id}`,
  method: 'DELETE',
})

export {
  getMemberships,
  createMembership,
  updateMembership,
  deleteMembership,
  updateMembershipPrizesOrder,
}
